<script setup lang="ts">
const formChoose = defineModel('formChoose');
const dialogFormVisible = defineModel('dialogFormVisible');

const handleClose = () => {
  formChoose.value = '';
  dialogFormVisible.value = false;
};
</script>

<template>
  <div class="wrong-sex-card">
    <p>恭喜領取成功 🎉</p>
    <p>準備和老師互動了嗎？</p>

    <button @click="handleClose">完成</button>
  </div>
</template>

<style scoped lang="scss">
.wrong-sex-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 290px;
  padding: 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #191919cc;
  }

  button {
    width: 100%;
    border: none;
    background-color: #f74768;
    color: #ffffff;
    font-size: 16px;
    border-radius: 4px;
    padding: 8px 24px;
    cursor: pointer;
    margin-top: 8px;
  }
}

.junior-landing-page > .main-content > .popup-overlay > .wrong-sex-card > button {
  background-color: $color-brownish-100;
}
</style>
